// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__38atM","content":"App_content__1GxqD"};